import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import CallToAction from "../../../components/CallToAction/CallToAction"
import Commissions from "../CostPerTransaction/Commissions"
import DiscountItem from "../Pricing/DiscountItem"
import PricingItem from "../Pricing/PricingItem"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)
const bodyClass = cx("row", "planColumnLastCell")

const CallToActionContainer = props => {
  const { plans, lang, onChangePlan } = props

  return (
    <>
      <div
        className={cx(
          bodyClass,
          "borderlessCell",
          "hidden-xs",
          "no-border",
          "no-bg"
        )}
      />

      {plans.map(plan => (
        <div
          className={cx(
            bodyClass,
            "flex-container",
            "f-j-center",
            "f-a-center",
            "mobileHeading"
          )}
          key={plan.name}
        >
          <div
            className={cx(
              "pricing",
              "hidden-sm",
              "hidden-md",
              "hidden-lg",
              "wd-min-content"
            )}
          >
            <div className="flex-container f-a-center m-t-25">
              {plan.isDiscountApplied ? (
                <DiscountItem
                  priceToPay={plan.discount.priceToPay}
                  isFree={plan.discount.isFree}
                  duration={plan.discount.type.duration}
                  unit={plan.discount.type.unit}
                  currency={plan.discount.price.currency}
                  priceBeforeDiscount={plan.price.net_amount}
                  lang={lang}
                />
              ) : (
                <PricingItem price={plan.price} lang={lang} />
              )}
              <div className="flex-container m-l-20 m-r-20">
                <p className={`${gridStyles.plus} fs-32 w400`}>+</p>
              </div>
              <Commissions
                commissions={plan.commission}
                lang={lang}
                price={plan.price}
              />
            </div>
          </div>
          <div className="m-v-40">
            <CallToAction plan={plan} onChangePlan={onChangePlan} lang={lang} />
          </div>
        </div>
      ))}
    </>
  )
}

CallToActionContainer.propTypes = {
  plans: PropTypes.array,
  lang: PropTypes.string,
  onChangePlan: PropTypes.func,
}

CallToActionContainer.defaultProps = {
  plans: [],
  lang: "en",
  onChangePlan: () => {},
}

export default CallToActionContainer
